import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["collapsible", "originalContent", "diffContent", "toggleButton"]

  toggle(event) {
    event.preventDefault()

    if (!this.collapsibleTarget.classList.contains("in")) {
      $(this.collapsibleTarget).collapse("show")
    }

    this.originalContentTarget.classList.toggle("hidden")
    this.diffContentTarget.classList.toggle("hidden")

    if (this.originalContentTarget.classList.contains("hidden")) {
      this.toggleButtonTarget.textContent = "Hide Changes"
    } else {
      this.toggleButtonTarget.textContent = "View Changes"
    }
  }
}
